import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import { PURPOSE_JOIN_DONATE } from 'pages/purpose/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import styles from './styles.scss'

const PurposeJoinAndDonate = ({ isPhone, t }) => {
  const { image } = PURPOSE_JOIN_DONATE
  const imageDesc = hasLocizeTranslation(t, image.descKey, image.desc)

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {!isPhone && (
        <span className={clsx('purpose-jd__image-desc', Typo.h4)}>
          {imageDesc}
        </span>
      )}
      <div className="purpose-jd__content-wrapper">
        <ResponsiveImage
          className={clsx(Typo.h6, 'purpose-jd__image')}
          imgRatio={image.ratio}
          src={image.src}
        >
          {isPhone && <div className="overlay">{imageDesc}</div>}
        </ResponsiveImage>
        <div className="purpose-jd__wrapper">
          <span
            className={clsx(
              'purpose-jd__title',
              isPhone ? Typo.subtitle2 : Typo.subtitle1,
            )}
          >
            {hasLocizeTranslation(
              t,
              PURPOSE_JOIN_DONATE.titleKey,
              PURPOSE_JOIN_DONATE.title,
            )}
          </span>
          <span className={clsx('purpose-jd__subtitle', Typo.body2)}>
            {hasLocizeTranslation(
              t,
              PURPOSE_JOIN_DONATE.subtitleKey,
              PURPOSE_JOIN_DONATE.subtitle,
            )}
          </span>
          {isPhone && (
            <Link
              href={PURPOSE_JOIN_DONATE.ctaHref}
              as={PURPOSE_JOIN_DONATE.ctaAs}
            >
              <a>
                <Button type={BUTTON_TYPES.primary} className="purpose-jd__cta">
                  {hasLocizeTranslation(
                    t,
                    PURPOSE_JOIN_DONATE.ctaKey,
                    PURPOSE_JOIN_DONATE.cta,
                  )}
                </Button>
              </a>
            </Link>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

PurposeJoinAndDonate.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export default PurposeJoinAndDonate
